import { reportError } from '@/instrumentation'
import { Audience, LTD } from '@/state/AppConfig'

export enum SurveyName {
  TYCE_AUDIENCE = 'TYCE_AUDIENCE',

  PEDRO_0_PRE = 'PEDRO_MORNING_PRE',
  PEDRO_0_POST = 'PEDRO_MORNING_POST',
  PEDRO_1_PRE = 'PEDRO_SCIENCE_PRE',
  PEDRO_1_POST = 'PEDRO_SCIENCE_POST',

  CARIS_0_PRE = 'CARIS_SOCIAL_STUDIES_PRE',
  CARIS_0_POST = 'CARIS_SOCIAL_STUDIES_POST',
  CARIS_1_PRE = 'CARIS_DANCE_PRE',
  CARIS_1_POST = 'CARIS_DANCE_POST',

  FRANCESCA_0_PRE = 'FRANCESCA_MATH_PRE',
  FRANCESCA_0_POST = 'FRANCESCA_MATH_POST',
  FRANCESCA_1_PRE = 'FRANCESCA_GROCERY_PRE',
  FRANCESCA_1_POST = 'FRANCESCA_GROCERY_POST',
}

export enum SurveyStartKey {
  PEDRO_0_PRE_USER_ID = 'PEDRO_MORNING_PRE_USER_ID',
  PEDRO_0_POST_USER_ID = 'PEDRO_MORNING_POST_USER_ID',
  PEDRO_1_PRE_USER_ID = 'PEDRO_SCIENCE_PRE_USER_ID',
  PEDRO_1_POST_USER_ID = 'PEDRO_SCIENCE_POST_USER_ID',

  CARIS_0_PRE_USER_ID = 'CARIS_SOCIAL_STUDIES_PRE_USER_ID',
  CARIS_0_POST_USER_ID = 'CARIS_SOCIAL_STUDIES_POST_USER_ID',
  CARIS_1_PRE_USER_ID = 'CARIS_DANCE_PRE_USER_ID',
  CARIS_1_POST_USER_ID = 'CARIS_DANCE_POST_USER_ID',

  FRANCESCA_0_PRE_USER_ID = 'FRANCESCA_MATH_PRE_USER_ID',
  FRANCESCA_0_POST_USER_ID = 'FRANCESCA_MATH_POST_USER_ID',
  FRANCESCA_1_PRE_USER_ID = 'FRANCESCA_GROCERY_PRE_USER_ID',
  FRANCESCA_1_POST_USER_ID = 'FRANCESCA_GROCERY_POST_USER_ID',
}

export enum SurveyAudienceKey {
  PEDRO_0_PRE_AUDIENCE = 'PEDRO_MORNING_PRE_AUDIENCE',
  PEDRO_0_POST_AUDIENCE = 'PEDRO_MORNING_POST_AUDIENCE',
  PEDRO_1_PRE_AUDIENCE = 'PEDRO_SCIENCE_PRE_AUDIENCE',
  PEDRO_1_POST_AUDIENCE = 'PEDRO_SCIENCE_POST_AUDIENCE',

  CARIS_0_PRE_AUDIENCE = 'CARIS_SOCIAL_STUDIES_PRE_AUDIENCE',
  CARIS_0_POST_AUDIENCE = 'CARIS_SOCIAL_STUDIES_POST_AUDIENCE',
  CARIS_1_PRE_AUDIENCE = 'CARIS_DANCE_PRE_AUDIENCE',
  CARIS_1_POST_AUDIENCE = 'CARIS_DANCE_POST_AUDIENCE',

  FRANCESCA_0_PRE_AUDIENCE = 'FRANCESCA_MATH_PRE_AUDIENCE',
  FRANCESCA_0_POST_AUDIENCE = 'FRANCESCA_MATH_POST_AUDIENCE',
  FRANCESCA_1_PRE_AUDIENCE = 'FRANCESCA_GROCERY_PRE_AUDIENCE',
  FRANCESCA_1_POST_AUDIENCE = 'FRANCESCA_GROCERY_POST_AUDIENCE',
}

export type SurveyQuestionKey = keyof typeof questionKeyMap

// create a map of question keys to their string values
const questionKeyMap = {
  // pedro scenario 1 before
  ['PEDRO_MORNING_PRE_TF_ADHD_DISTRACTION']: 'pedro.0.before.binary.1',
  ['PEDRO_MORNING_PRE_TF_ADHD_ROUTINES']: 'pedro.0.before.binary.2',
  ['PEDRO_MORNING_PRE_TF_ADHD_EMOTIONS']: 'pedro.0.before.binary.3',
  ['PEDRO_MORNING_PRE_LIKERT_ADHD_DIFFERENT_FROM_ME']: 'pedro.0.before.likert.1',
  ['PEDRO_MORNING_PRE_LIKERT_ADHD_FEEL_FRUSTRATED']: 'pedro.0.before.likert.2',
  ['PEDRO_MORNING_PRE_LIKERT_ADHD_FEEL_SORRY']: 'pedro.0.before.likert.3',
  ['PEDRO_MORNING_PRE_LIKERT_ADHD_SPECIAL_TREATMENT']: 'pedro.0.before.likert.4',
  // pedro scenario 1 after
  ['PEDRO_MORNING_POST_TF_ADHD_DISTRACTION']: 'pedro.0.after.binary.1',
  ['PEDRO_MORNING_POST_TF_ADHD_ROUTINES']: 'pedro.0.after.binary.2',
  ['PEDRO_MORNING_POST_TF_ADHD_EMOTIONS']: 'pedro.0.after.binary.3',
  ['PEDRO_MORNING_POST_LIKERT_ADHD_DIFFERENT_FROM_ME']: 'pedro.0.after.likert.1',
  ['PEDRO_MORNING_POST_LIKERT_ADHD_FEEL_FRUSTRATED']: 'pedro.0.after.likert.2',
  ['PEDRO_MORNING_POST_LIKERT_ADHD_FEEL_SORRY']: 'pedro.0.after.likert.3',
  ['PEDRO_MORNING_POST_LIKERT_ADHD_SPECIAL_TREATMENT']: 'pedro.0.after.likert.4',
  // pedro scenario 2 before
  ['PEDRO_SCIENCE_PRE_TF_ADHD_IMPULSE']: 'pedro.1.before.binary.1',
  ['PEDRO_SCIENCE_PRE_TF_ADHD_REMINDERS']: 'pedro.1.before.binary.2',
  ['PEDRO_SCIENCE_PRE_TF_ADHD_DAYDREAMING']: 'pedro.1.before.binary.3',
  ['PEDRO_SCIENCE_PRE_LIKERT_ADHD_DIFFERENT_FROM_ME']: 'pedro.1.before.likert.1',
  ['PEDRO_SCIENCE_PRE_LIKERT_ADHD_FEEL_FRUSTRATED']: 'pedro.1.before.likert.2',
  ['PEDRO_SCIENCE_PRE_LIKERT_ADHD_FEEL_SORRY']: 'pedro.1.before.likert.3',
  ['PEDRO_SCIENCE_PRE_LIKERT_ADHD_SPECIAL_TREATMENT']: 'pedro.1.before.likert.4',
  // pedro scenario 2 after
  ['PEDRO_SCIENCE_POST_TF_ADHD_IMPULSE']: 'pedro.1.after.binary.1',
  ['PEDRO_SCIENCE_POST_TF_ADHD_REMINDERS']: 'pedro.1.after.binary.2',
  ['PEDRO_SCIENCE_POST_TF_ADHD_DAYDREAMING']: 'pedro.1.after.binary.3',
  ['PEDRO_SCIENCE_POST_LIKERT_ADHD_DIFFERENT_FROM_ME']: 'pedro.1.after.likert.1',
  ['PEDRO_SCIENCE_POST_LIKERT_ADHD_FEEL_FRUSTRATED']: 'pedro.1.after.likert.2',
  ['PEDRO_SCIENCE_POST_LIKERT_ADHD_FEEL_SORRY']: 'pedro.1.after.likert.3',
  ['PEDRO_SCIENCE_POST_LIKERT_ADHD_SPECIAL_TREATMENT']: 'pedro.1.after.likert.4',

  // caris scenario 1 before
  ['CARIS_SOCIAL_STUDIES_PRE_TF_DYSLEXIA_VISION']: 'caris.0.before.binary.1',
  ['CARIS_SOCIAL_STUDIES_PRE_TF_DYSLEXIA_SPELLING']: 'caris.0.before.binary.2',
  ['CARIS_SOCIAL_STUDIES_PRE_TF_DYSLEXIA_INSTRUCTION']: 'caris.0.before.binary.3',
  ['CARIS_SOCIAL_STUDIES_PRE_LIKERT_DYSLEXIA_DIFFERENT_FROM_ME']: 'caris.0.before.likert.1',
  ['CARIS_SOCIAL_STUDIES_PRE_LIKERT_DYSLEXIA_FEEL_FRUSTRATED']: 'caris.0.before.likert.2',
  ['CARIS_SOCIAL_STUDIES_PRE_LIKERT_DYSLEXIA_FEEL_SORRY']: 'caris.0.before.likert.3',
  ['CARIS_SOCIAL_STUDIES_PRE_LIKERT_DYSLEXIA_SPECIAL_TREATMENT']: 'caris.0.before.likert.4',
  // caris scenario 1 after
  ['CARIS_SOCIAL_STUDIES_POST_TF_DYSLEXIA_VISION']: 'caris.0.after.binary.1',
  ['CARIS_SOCIAL_STUDIES_POST_TF_DYSLEXIA_SPELLING']: 'caris.0.after.binary.2',
  ['CARIS_SOCIAL_STUDIES_POST_TF_DYSLEXIA_INSTRUCTION']: 'caris.0.after.binary.3',
  ['CARIS_SOCIAL_STUDIES_POST_LIKERT_DYSLEXIA_DIFFERENT_FROM_ME']: 'caris.0.after.likert.1',
  ['CARIS_SOCIAL_STUDIES_POST_LIKERT_DYSLEXIA_FEEL_FRUSTRATED']: 'caris.0.after.likert.2',
  ['CARIS_SOCIAL_STUDIES_POST_LIKERT_DYSLEXIA_FEEL_SORRY']: 'caris.0.after.likert.3',
  ['CARIS_SOCIAL_STUDIES_POST_LIKERT_DYSLEXIA_SPECIAL_TREATMENT']: 'caris.0.after.likert.4',
  // caris scenario 2 before
  ['CARIS_DANCE_PRE_TF_DYSLEXIA_SMART']: 'caris.1.before.binary.1',
  ['CARIS_DANCE_PRE_TF_DYSLEXIA_LEFT_RIGHT']: 'caris.1.before.binary.2',
  ['CARIS_DANCE_PRE_TF_DYSLEXIA_FOLLOW_DIRECTIONS']: 'caris.1.before.binary.3',
  ['CARIS_DANCE_PRE_LIKERT_DYSLEXIA_DIFFERENT_FROM_ME']: 'caris.1.before.likert.1',
  ['CARIS_DANCE_PRE_LIKERT_DYSLEXIA_FEEL_FRUSTRATED']: 'caris.1.before.likert.2',
  ['CARIS_DANCE_PRE_LIKERT_DYSLEXIA_FEEL_SORRY']: 'caris.1.before.likert.3',
  ['CARIS_DANCE_PRE_LIKERT_DYSLEXIA_SPECIAL_TREATMENT']: 'caris.1.before.likert.4',
  // caris scenario 2 after
  ['CARIS_DANCE_POST_TF_DYSLEXIA_SMART']: 'caris.1.after.binary.1',
  ['CARIS_DANCE_POST_TF_DYSLEXIA_LEFT_RIGHT']: 'caris.1.after.binary.2',
  ['CARIS_DANCE_POST_TF_DYSLEXIA_FOLLOW_DIRECTIONS']: 'caris.1.after.binary.3',
  ['CARIS_DANCE_POST_LIKERT_DYSLEXIA_DIFFERENT_FROM_ME']: 'caris.1.after.likert.1',
  ['CARIS_DANCE_POST_LIKERT_DYSLEXIA_FEEL_FRUSTRATED']: 'caris.1.after.likert.2',
  ['CARIS_DANCE_POST_LIKERT_DYSLEXIA_FEEL_SORRY']: 'caris.1.after.likert.3',
  ['CARIS_DANCE_POST_LIKERT_DYSLEXIA_SPECIAL_TREATMENT']: 'caris.1.after.likert.4',

  // francesca scenario 1 before
  ['FRANCESCA_MATH_PRE_TF_DYSCALCULIA_MATH_FACTS']: 'francesca.0.before.binary.1',
  ['FRANCESCA_MATH_PRE_TF_DYSCALCULIA_USE_VISUAL_TOOLS']: 'francesca.0.before.binary.2',
  ['FRANCESCA_MATH_PRE_TF_DYSCALCULIA_MATH_ANXIETY']: 'francesca.0.before.binary.3',
  ['FRANCESCA_MATH_PRE_LIKERT_DYSCALCULIA_DIFFERENT_FROM_ME']: 'francesca.0.before.likert.1',
  ['FRANCESCA_MATH_PRE_LIKERT_DYSCALULIA_FEEL_FRUSTRATED']: 'francesca.0.before.likert.2',
  ['FRANCESCA_MATH_PRE_LIKERT_DYSCALCULIA_FEEL_SORRY']: 'francesca.0.before.likert.3',
  ['FRANCESCA_MATH_PRE_LIKERT_DYSCALCULIA_SPECIAL_TREATMENT']: 'francesca.0.before.likert.4',
  // francesca scenario 1 after
  ['FRANCESCA_MATH_POST_TF_DYSCALCULIA_MATH_FACTS']: 'francesca.0.after.binary.1',
  ['FRANCESCA_MATH_POST_TF_DYSCALCULIA_USE_VISUAL_TOOLS']: 'francesca.0.after.binary.2',
  ['FRANCESCA_MATH_POST_TF_DYSCALCULIA_MATH_ANXIETY']: 'francesca.0.after.binary.3',
  ['FRANCESCA_MATH_POST_LIKERT_DYSCALCULIA_DIFFERENT_FROM_ME']: 'francesca.0.after.likert.1',
  ['FRANCESCA_MATH_POST_LIKERT_DYSCALULIA_FEEL_FRUSTRATED']: 'francesca.0.after.likert.2',
  ['FRANCESCA_MATH_POST_LIKERT_DYSCALCULIA_FEEL_SORRY']: 'francesca.0.after.likert.3',
  ['FRANCESCA_MATH_POST_LIKERT_DYSCALCULIA_SPECIAL_TREATMENT']: 'francesca.0.after.likert.4',
  // francesca scenario 2 before
  ['FRANCESCA_GROCERY_PRE_TF_DYSCALCULIA_MENTAL_MATH']: 'francesca.1.before.binary.1',
  ['FRANCESCA_GROCERY_PRE_TF_DYSCALCULIA_MONEY']: 'francesca.1.before.binary.2',
  ['FRANCESCA_GROCERY_PRE_TF_DYSCALCULIA_CALCULATOR']: 'francesca.1.before.binary.3',
  ['FRANCESCA_GROCERY_PRE_LIKERT_DYSCALCULIA_DIFFERENT_FROM_ME']: 'francesca.1.before.likert.1',
  ['FRANCESCA_GROCERY_PRE_LIKERT_DYSCALULIA_FEEL_FRUSTRATED']: 'francesca.1.before.likert.2',
  ['FRANCESCA_GROCERY_PRE_LIKERT_DYSCALCULIA_FEEL_SORRY']: 'francesca.1.before.likert.3',
  ['FRANCESCA_GROCERY_PRE_LIKERT_DYSCALCULIA_SPECIAL_TREATMENT']: 'francesca.1.before.likert.4',
  // francesca scenario 2 after
  ['FRANCESCA_GROCERY_POST_TF_DYSCALCULIA_MENTAL_MATH']: 'francesca.1.after.binary.1',
  ['FRANCESCA_GROCERY_POST_TF_DYSCALCULIA_MONEY']: 'francesca.1.after.binary.2',
  ['FRANCESCA_GROCERY_POST_TF_DYSCALCULIA_CALCULATOR']: 'francesca.1.after.binary.3',
  ['FRANCESCA_GROCERY_POST_LIKERT_DYSCALCULIA_DIFFERENT_FROM_ME']: 'francesca.1.after.likert.1',
  ['FRANCESCA_GROCERY_POST_LIKERT_DYSCALULIA_FEEL_FRUSTRATED']: 'francesca.1.after.likert.2',
  ['FRANCESCA_GROCERY_POST_LIKERT_DYSCALCULIA_FEEL_SORRY']: 'francesca.1.after.likert.3',
  ['FRANCESCA_GROCERY_POST_LIKERT_DYSCALCULIA_SPECIAL_TREATMENT']: 'francesca.1.after.likert.4',
}

// get the question key from questionKeyMap value
export function getSurveyQuestionKey(key: string): SurveyQuestionKey | undefined {
  return (Object.keys(questionKeyMap) as Array<keyof typeof questionKeyMap>).find((k) => questionKeyMap[k] === key) as
    SurveyQuestionKey | undefined
}

export default class Survey {
  private static _currentSurveyId: SurveyName = SurveyName.TYCE_AUDIENCE
  private static _currentResponseId: string | undefined

  private static async post(responses: { key: string; response: string }[], key: SurveyName) {
    const host = import.meta.env.VITE_ENABLE_PROXY
      ? `/api`
      : import.meta.env.VITE_API_URL || 'https://api-qa.understood.org'

    return await fetch(`${host}/behavioral-health/v1/surveys/${key}/response?survey_version=3`, {
      method: 'POST',
      headers: {
        //   Authorization: `Bearer ${this._authenticationToken}`,
        'Content-type': 'Application/json',
      },
      body: JSON.stringify({
        responses,
      }),
    })
      .then((response) => {
        console.log('Response:', response)
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .catch((error) => {
        console.error('There was a problem with the fetch operation:', error)
        reportError(error, { service: 'survey', op: 'post', survey: key })
        throw error
      })
  }

  private static async waitSurveyStart() {
    // if the update method is called before the start method completes, we dont have the _currentResponseId yet
    // it might happen if the user clicks on the next button fast and on slow connections
    const startTime = Date.now()
    while (!this._currentResponseId) {
      if (Date.now() - startTime > 60000) {
        const error = new Error('Survey could not be started within 60 seconds')
        reportError(error, { service: 'survey', op: 'waitSurveyStart', survey: this._currentSurveyId })
        throw error
      }
      await new Promise((resolve) => setTimeout(resolve, 5000))
    }
  }

  // how to get session: https://www.understood.org/members/89dc3fbcd1e01397f5e3b1ca2e2ff94c91daaa6d?
  // private static _authenticationToken: string = import.meta.env.VITE_AUTH_TOKEN

  public static async audience(audience: Audience, ltd: LTD, userId?: string) {
    // currently, audience is a survey with one question only, it doesnt need to be updated later
    return await this.post(
      [
        {
          key: 'AUDIENCE',
          response: audience,
        },
        {
          key: 'LTD',
          response: ltd,
        },
        {
          key: 'SP_USER_ID',
          response: userId,
        },
      ],
      SurveyName.TYCE_AUDIENCE
    )
  }

  public static async start(
    questionId: keyof typeof SurveyStartKey,
    audienceQuestionId: keyof typeof SurveyAudienceKey,
    key: keyof typeof SurveyName,
    userId?: string,
    audience?: Audience
  ) {
    // when starting a survey, save the key and response id to be used by the update method
    this._currentSurveyId = SurveyName[key]
    this._currentResponseId = undefined
    return await this.post(
      [
        {
          key: SurveyStartKey[questionId],
          response: userId,
        },
        {
          key: SurveyAudienceKey[audienceQuestionId],
          response: audience,
        },
      ],
      this._currentSurveyId
    ).then((data) => {
      if (!data?.response_id) {
        const error = new Error('Survey start failed: server did not return a response ID')
        reportError(error, { service: 'survey', op: 'start', survey: this._currentSurveyId })
        throw error
      }
      this._currentResponseId = data['response_id']
      return data
    })
  }

  public static async update(questionKey: SurveyQuestionKey, value: string) {
    await this.waitSurveyStart()

    const responseId = this._currentResponseId
    if (!responseId) {
      const error = new Error('Response ID is not set after survey start')
      reportError(error, { service: 'survey', op: 'update', survey: this._currentSurveyId })
      throw error
    }

    // update the survey started by the start method
    const host = import.meta.env.VITE_ENABLE_PROXY
      ? `/api`
      : import.meta.env.VITE_API_URL || 'https://api-qa.understood.org'

    return await fetch(
      `${host}/behavioral-health/v1/surveys/${this._currentSurveyId}/response/${responseId}?survey_version=3`,
      {
        method: 'PUT',
        headers: {
          //   Authorization: `Bearer ${this._authenticationToken}`,
          'Content-type': 'Application/json',
        },
        body: JSON.stringify({
          responses: [
            {
              key: questionKey,
              response: value,
            },
          ],
        }),
      }
    ).catch((error) => {
      reportError(error, { service: 'survey', op: 'update', survey: this._currentSurveyId })
      throw error
    })
  }
}
